// action

const ClickToPlayVideo = require('./action/content-blocks/click-to-play-video/script');
const ExpandingPhotoCols = require('./action/content-blocks/expanding-photo-cols/script');
const IconStats = require('./action/content-blocks/icon-stats/script');
const ReadMoreText = require('./action/content-blocks/read-more-text/script');
const ScrollOverlaySlides = require('./action/content-blocks/scroll-overlay-slides/script');
const ScrollSplitSlides = require('./action/content-blocks/scroll-split-slides/script');
const SplitReadMoreGraph = require('./action/content-blocks/split-read-more-graph/script');
const SplitTextStatImage = require('./action/content-blocks/split-text-stat-image/script');
const StatBanner = require('./action/content-blocks/stat-banner/script');

// impact

const FracturedGraphBlock = require('./impact/content-blocks/fractured-graph-block/script');
const HorizontalGraphBlock = require('./impact/content-blocks/horizontal-graph-block/script');
const VerticalGraphBlock = require('./impact/content-blocks/vertical-graph-block/script');
const StatBlock = require('./impact/content-blocks/stat-block/script');

// vision

const CEOHero = require('./vision/ceo-hero/script');
const Mission = require('./vision/mission/script');
const Quote = require('./vision/quote/script');

//

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-click-to-play-video]', function () {
		new ClickToPlayVideo($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-expanding-photo-cols]', function () {
		new ExpandingPhotoCols($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-icon-stats]', function () {
		new IconStats($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-read-more-text]', function () {
		new ReadMoreText($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-scroll-overlay-slides]', function () {
		new ScrollOverlaySlides($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-scroll-split-slides]', function () {
		new ScrollSplitSlides($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-read-more-graph]', function () {
		new SplitReadMoreGraph($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-text-stat-image]', function () {
		new SplitTextStatImage($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat-banner]', function () {
		new StatBanner($(this));
	});

	// vision

	window.SETTINGS.domScan.addElement($scanContainer, '[data-ceo-hero]', function() {
		new CEOHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-mission]', function() {
		new Mission(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-quote]', function() {
		new Quote(this, {});
	});

	// impact

	window.SETTINGS.domScan.addElement($scanContainer, '[data-fractured-graph-block]', function () {
		new FracturedGraphBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-horizontal-graph-block]', function () {
		new HorizontalGraphBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat-block]', function () {
		new StatBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-vertical-graph-block]', function () {
		new VerticalGraphBlock($(this));
	});
});
